import { trackEvent } from '@Services/analytics/tracking.service';

export const DnbEmbeddedIntroAnalyticsService = {
  trackPageView: () => {
    trackEvent('View DNB Embedded Intro');
  },
  trackGetStartedClick: () => {
    trackEvent('Act on DNB Embedded Intro', { Action: 'Get Started' });
  },
};
